<scope-theme></scope-theme>

@if (cultureCode) {
  <sss-navbar-header
    environment="{{ environmentName }}"
    data-html2canvas-ignore="true"
    culture="{{ cultureCode }}"
  >
    <sss-navbar-application-brand class="sss-navbar-separator">
      <span>{{ 'ServicePlanning' | translate }}</span>
    </sss-navbar-application-brand>
    <div class="sss-navbar-menu-divider"></div>
    <sss-navbar-brand></sss-navbar-brand>
  </sss-navbar-header>
}

<main>
  <router-outlet></router-outlet>
</main>

<app-no-internet-toastr></app-no-internet-toastr>

<toast-outlet />

@if (canAccessZendeskWidget) {
  <zendesk-widget [attr.user-language]="cultureCode"></zendesk-widget>
}
